import React  from "react";
import { FormatMessage } from "react-globalize";
import { getBulletAndText, getListItems } from "../globalizationUtils";

export default function SectionESign(props)
{
  let locale = props.locale || 'en';  

  return (
    <div id="esign">
    <div className="title" >
      <h3><FormatMessage locale={locale} path="quisqueyanaPolicy/esign/title" /></h3>
    </div>
    <p><FormatMessage locale={locale} path="quisqueyanaPolicy/esign/line1"/></p>
    <p><FormatMessage locale={locale} path="quisqueyanaPolicy/esign/line2"/></p>
    <div id="esignCOVERED_COMMUNICATIONS" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "esignCOVERED_COMMUNICATIONS", "quisqueyanaPolicy/esign/COVERED_COMMUNICATIONS/title")}</h4>
      <div className="esignCOVERED_COMMUNICATIONS collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/esign/COVERED_COMMUNICATIONS/info"/></p>
      </div>
    </div>
    <div id="esignMETHODS" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "esignMETHODS", "quisqueyanaPolicy/esign/METHODS/title")}</h4>
      <div className="esignMETHODS collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/esign/METHODS/info"/></p>
      </div>
    </div>
    <div id="esignREQUIREMENTS" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "esignREQUIREMENTS", "quisqueyanaPolicy/esign/REQUIREMENTS/title")}</h4>
      <div className="esignREQUIREMENTS collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/esign/REQUIREMENTS/note"/></p>
        <ol>
          {getListItems(locale, 3, "quisqueyanaPolicy/esign/REQUIREMENTS/list")}
        </ol>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/esign/REQUIREMENTS/postscript"/></p>
      </div>
    </div>
    <div id="esignWITHDRAW" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "esignWITHDRAW", "quisqueyanaPolicy/esign/WITHDRAW/title")}</h4>
      <div className="esignWITHDRAW collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/esign/WITHDRAW/info"/></p>
      </div>
    </div>
    <div id="esignPAPER_COPIES" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "esignPAPER_COPIES", "quisqueyanaPolicy/esign/PAPER_COPIES/title")}</h4>
      <div className="esignPAPER_COPIES collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/esign/PAPER_COPIES/info"/></p>
      </div>
    </div>
    <div id="esignUPDATING" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "esignUPDATING", "quisqueyanaPolicy/esign/UPDATING/title")}</h4>
      <div className="esignUPDATING collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/esign/UPDATING/info1"/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/esign/UPDATING/info2"/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/esign/UPDATING/info3"/></p>
      </div>
    </div>
    <div id="esignFEDERAL" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "esignFEDERAL", "quisqueyanaPolicy/esign/FEDERAL/title")}</h4>
      <div className="esignFEDERAL collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/esign/FEDERAL/info"/></p>
      </div>
    </div>
    <div id="esignTERMINATION" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "esignTERMINATION", "quisqueyanaPolicy/esign/TERMINATION/title")}</h4>
      <div className="esignTERMINATION collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/esign/TERMINATION/info"/></p>
      </div>
    </div>
  </div>
  )
}


// WEBPACK FOOTER //
// ./js/SectionQuisqueyanaPolicy/SectioneESign/SectionESign.js